import { ToNumber, ToString } from './utils';

const ConsumptionPointRegExp = new RegExp(/^5\d{9}$/);

export function ConsumptionPointValidation(str: string = '') {
  return ConsumptionPointRegExp.test(str);
}

const PartnerCodeRegExp = new RegExp(/^1\d{9}$/);

export function PartnerCodeValidation(str: string = '') {
  return PartnerCodeRegExp.test(str);
}

const CNPRegExp = new RegExp(/^([1-8])(0[0-9]|[1-9][0-9])(0[1-9]|1[0-2])(\d{2})(\d{2})(\d{3})(\d)$/);
const CNPControl = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];

export function CNPValidation(CNP: string = '') {
  CNP = ToString(CNP);

  if (CNPRegExp.test(CNP)) {
    let bigSum = 0;

    for (let i = 0; i < CNPControl.length; i++) {
      bigSum += ToNumber(CNP.charAt(i)) * CNPControl[i];
    }

    let ctrlDigit = bigSum % 11;

    if (ctrlDigit === 10) {
      ctrlDigit = 1;
    }

    return ctrlDigit === ToNumber(CNP[12]);
  }

  return false;
}
